import { TriggerEventType } from '@/constant/triggerEventType';
import { CART_RECOMMEND_SOURCE } from '@/views/wheelOfFortune/components/recommend/types';

export function isCartRecommendSource(source?: string | string[] | null): boolean {
  if (Array.isArray(source)) {
    return source.includes(CART_RECOMMEND_SOURCE);
  }
  return source === CART_RECOMMEND_SOURCE;
}

/**
 * FR-05：从推荐入口创建加购弹窗时的展示规则默认值。
 */
export function applyCartRecommendDisplayDefaults(formData: any): void {
  if (!formData?.settings || Number(formData.triggerEventType) !== TriggerEventType.ADD_TO_CART) {
    return;
  }

  const rules = {
    ...(formData.settings.rules || {}),
    addPurchaseDownShow: true,
    addPurchaseJumpPageShow: false,
    addPurchaseDown: 30,
    unsubscribedSubscriber: true,
    subscribedSubscriber: false,
  };

  const targeting = {
    ...(formData.settings.targeting || {}),
    excludePages: ['4', '5'],
  };

  formData.settings.rules = rules;
  formData.settings.targeting = targeting;
}
